module.exports = __webpack_public_path__ + "img/Wharton.b2d153cd.png";